module.exports = __webpack_public_path__ + "static/media/brian.d3ba2905.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/brian.jpg
// module id = 615
// module chunks = 0